<template>
  <div class="orderGoods">
    <div class="total">1 Item</div>
    <div class="goodWrapper">
      <div class="item acea-row row-between-wrapper">
        <div class="pictrue">
          <img  :src="cartInfo.image" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1" >{{ cartInfo.name }}</div>
            <div class="num">x {{ num }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    },
    num:String,
    gameState:{
      type: String,
      default:0,
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
